/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const NoCreditCheck: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M16.707 11.707L13.4141 15L16.707 18.293L15.293 19.707L12 16.4141L8.70703 19.707L7.29297 18.293L10.5859 15L7.29297 11.707L8.70703 10.293L12 13.5859L15.293 10.293L16.707 11.707ZM4.5752 6.92188L5.26562 7.64551C3.5497 9.28148 2.5 11.5276 2.5 14H0.5C0.5 10.9437 1.80144 8.18442 3.88574 6.19727L4.5752 6.92188ZM20.1143 6.19727C22.1986 8.18442 23.5 10.9437 23.5 14H21.5C21.5 11.5276 20.4503 9.28148 18.7344 7.64551L19.4248 6.92188L20.1143 6.19727ZM6.2666 4.45312C9.77934 2.51583 14.2207 2.51583 17.7334 4.45312L17.25 5.3291L16.7666 6.2041C13.8553 4.5987 10.1447 4.5987 7.2334 6.2041L6.75 5.3291L6.2666 4.45312Z'
      fill='currentColor'
    />
  </React.Fragment>
)
